import React from 'react';

import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { types as sdkTypes } from '../../util/sdkLoader';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SCHOOL_DONATION, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

// Validate the assumption that the donation exists and the amount
// is zero or negative (deduction from provider payout).
const isValidDonation = donationLineItem => {
  return donationLineItem.lineTotal instanceof Money && donationLineItem.lineTotal.amount <= 0;
};

/**
 * A component that renders the school donation as a line item.
 * Only shown to the provider (seller).
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {boolean} props.isProvider - Whether the current user is the provider
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemSchoolDonationMaybe = props => {
  const { lineItems, isProvider, intl } = props;

  const donationLineItem = lineItems.find(
    item => item.code === LINE_ITEM_SCHOOL_DONATION && !item.reversal
  );

  let donationItem = null;

  if (isProvider && donationLineItem) {
    if (!isValidDonation(donationLineItem)) {
      // eslint-disable-next-line no-console
      console.error('invalid school donation line item:', donationLineItem);
      throw new Error('School donation should be present and the value should be zero or negative');
    }

    const donation = donationLineItem.lineTotal;
    const formattedDonation = donation ? formatMoney(intl, donation) : null;

    donationItem = (
      <div className={css.lineItem}>
        <span className={css.itemLabel}>
          <FormattedMessage id="OrderBreakdown.schoolDonation" />
        </span>
        <span className={css.itemValue}>{formattedDonation}</span>
      </div>
    );
  }

  return donationItem;
};

export default LineItemSchoolDonationMaybe;
